export default "__VITE_ASSET__5901a5a1__"